export const Common = {
  About: {
    path: '/about',
    name: 'about'
  },
  Error: {
    path: '/errorpage',
    name: 'errorPage'
  },
  PageNotFound: {
    path: '*',
    name: 'pageNotFound'
  },
  Welcome: {
    path: '/welcome/:module',
    name: 'welcome'
  },
  UserPreferences: {
    path: '/userpreferences',
    name: 'userPreferences'
  }
};
